import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Cookies from "universal-cookie";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './sample.css'; // Import the CSS file for styling
import './style.css';
import { Link } from 'react-router-dom';
import BasicLayout from 'layouts/authentication/components/BasicLayout';
const cookies = new Cookies();

const footballTeams = [
  // La Liga Teams
  { name: 'Atlético Madrid', city: 'Madrid', link: 'https://i.pinimg.com/474x/de/3e/ee/de3eee5ae35be3860e92edad12c27524.jpg' },
  { name: 'Barcelona', city: 'Barcelona', link: 'https://i.pinimg.com/564x/25/1f/2f/251f2fa166c24fce0f32d5df92b97af3.jpg' },
  { name: 'Real Betis', city: 'Seville', link: 'https://i.pinimg.com/736x/fc/76/4d/fc764d3ee695fa5e7de9f1803bde7201.jpg' },
  { name: 'Real Madrid', city: 'Madrid', link: 'https://i.pinimg.com/564x/a9/9d/e5/a99de595c174374b726db23f9410e521.jpg' },
  { name: 'Real Sociedad', city: 'San Sebastián', link: 'https://i.pinimg.com/564x/2d/98/ea/2d98ea2d4f3e777c9a5c96bba9f28049.jpg' },
  { name: 'Sevilla', city: 'Seville', link: 'https://pool.img.aptoide.com/appupdater/5466346c4e29958c1d5fe547abc20e9e_icon.png' },
  { name: 'Dortmund', city: 'Dortmund', link: 'https://i.pinimg.com/564x/e9/4f/44/e94f440b45311551658c72f23b1dc41e.jpg' },

  // Premier League Teams
  { name: 'Arsenal', city: 'London', link: 'https://i.pinimg.com/564x/96/de/68/96de680b8912c5ce258812b04f5d364e.jpg' },
  { name: 'Chelsea', city: 'London', link: 'https://i.pinimg.com/564x/a8/73/b1/a873b16a7b5c8a860564bbdbd01a3700.jpg' },
  { name: 'Liverpool', city: 'Liverpool', link: 'https://i.pinimg.com/564x/f5/a8/2e/f5a82e072b22d42cc3fe16fd037ce057.jpg' },
  { name: 'Manchester City', city: 'Manchester', link: 'https://i.pinimg.com/564x/ad/f3/77/adf37701f39587a5407598c81ce6e0f1.jpg' },
  { name: 'Manchester United', city: 'Manchester', link: 'https://i.pinimg.com/564x/64/76/d0/6476d0f4d2bb83ab38ede714ec0a106f.jpg' },
  { name: 'Tottenham Hotspur', city: 'London', link: 'https://i.pinimg.com/564x/4c/ed/eb/4cedeb454c94247316042d9862beb86e.jpg' },
  { name: 'Newcastle United', city: 'Newcastle upon Tyne', link: 'https://i.pinimg.com/564x/10/6e/f8/106ef8cec08e7ab2e463a636a7929813.jpg' },

  // Ligue 1 Teams
  { name: 'Paris Saint-Germain', city: 'Paris', link: 'https://i.pinimg.com/564x/76/2d/d9/762dd9449341153b761d388153d77026.jpg' },
  // { name: 'Marseille', city: 'Marseille', link: 'URL_FOR_MARSEILLE_LOGO' },
  // { name: 'Lyon', city: 'Lyon', link: 'URL_FOR_LYON_LOGO' },
  // { name: 'Monaco', city: 'Monaco', link: 'URL_FOR_MONACO_LOGO' },
  // { name: 'Lille', city: 'Lille', link: 'URL_FOR_LILLE_LOGO' },
  // { name: 'Nice', city: 'Nice', link: 'URL_FOR_NICE_LOGO' },

  // //Other Teams
  // { name: 'Internazionale', city: 'Milan', link: 'URL_FOR_TROYES_LOGO' },
  // { name: 'AC Milan', city: 'Milan', link: 'URL_FOR_TROYES_LOGO' },
  // { name: 'Juventus', city: 'Turin', link: 'URL_FOR_JUVENTUS_LOGO' },
  { name: 'Bayern Munich', city: 'Munich', link: 'https://i.pinimg.com/564x/87/e5/56/87e556a63ec58ec1bb8630922c417849.jpg' },
];

const TeamCard = ({ team, isSelected }) => {
  return (
    <div className={`team-card ${isSelected ? 'pressed' : ''}`}>
      <div className="image-wrapper">
        <img src={team.link} alt={team.name} />
      </div>
    </div>
  );
};

const Select_Team = () => {
  const [selectedTeamIndex, setSelectedTeamIndex] = useState(0);
  const [authenticated, setAuthenticated] = useState(!!cookies.get("auth-token2"));

  const handleNext = () => {
    setSelectedTeamIndex((selectedTeamIndex + 1) % footballTeams.length);
  };

  const handlePrev = () => {
    setSelectedTeamIndex((selectedTeamIndex - 1 + footballTeams.length) % footballTeams.length);
  };

  useEffect(() => {
    const checkAuthentication = () => {
      setAuthenticated(!!cookies.get("auth-token2"));
    };

    checkAuthentication();

    return () => {
    };
  }, []);

  return (
    <BasicLayout image="https://t4.ftcdn.net/jpg/04/16/15/39/360_F_416153962_OM9K00x0JZo85BpbbeXjLQHoG9hPvqjA.jpg">
      <div className="app">
        <h2 style={{ fontWeight: "900", fontFamily: "cursive" }}>{footballTeams[selectedTeamIndex].name}</h2>
        <ToastContainer />
        <div className="carousel">
          <button onClick={handlePrev}>&lt;</button>
          <TeamCard team={footballTeams[selectedTeamIndex]} isSelected={true} />
          <button onClick={handleNext}>&gt;</button>
        </div>
        <div style={{ marginTop: "2rem", paddingBottom: '30px' }}>
          {!authenticated || cookies.get('auth-token2') && cookies.get('auth-token2').teamName!==footballTeams[selectedTeamIndex].name ? (
            cookies.get('auth-token1') ? (
              <button className='sub' onClick={() => {
                console.log(footballTeams[selectedTeamIndex].name)
                cookies.set('auth-token2', JSON.stringify({ teamLink: footballTeams[selectedTeamIndex].link, teamName: footballTeams[selectedTeamIndex].name }), { sameSite: 'None', secure: true });
                document.getElementById('aboutLink').click();
              }}>SUBMIT</button>
            ) : (
              <p>SIGN IN FIRST</p>
            )
            
          ) : (
            <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green', fontSize: '2rem', marginTop: '1rem' }} />
          )}
        </div>
        <Link id="aboutLink" to="/dashboard" style={{ display: 'none' }}>Go to About</Link>
      </div>
    </BasicLayout>
  );
};

export default Select_Team;